import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";

export const DeleteReadingButton = ({ onDelete, testid = "delete-reading-btn" }) => {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);

  const handle = async () => {
    if (!confirming) {
      setConfirming(true);
      setTimeout(() => setConfirming(false), 4000);
      return;
    }
    setBusy(true);
    try {
      await onDelete();
    } finally {
      setBusy(false);
      setConfirming(false);
    }
  };

  return (
    <button onClick={handle} disabled={busy} data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-[11px] rounded-full px-3.5 py-1 border transition-colors disabled:opacity-50 ${confirming ? "border-red-400/60 text-red-300 bg-red-500/10" : "border-purple-400/30 text-purple-300/80 hover:border-red-400/50 hover:text-red-300"}`}>
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Trash2 className="w-3 h-3" />}
      <span data-testid={`${testid}-label`}>{confirming ? "Confermi? Elimina" : "Elimina testo"}</span>
    </button>
  );
};
